export const schedule: Record<string, string> = {
  'schedule.currentMonth': 'Tháng hiện tại',
  'schedule.targetMonth': 'Tháng đăng ký',
  'schedule.mySchedule': 'Ca làm việc của tôi',
  'schedule.registerTitle': 'Đăng ký lịch làm việc',
  'schedule.registerBtn': 'Đăng ký',
  'schedule.notRegistered': 'Chưa đăng ký (mặc định: 9h)',
  'schedule.deadline': 'Hạn đăng ký',
  'schedule.windowOpen': 'Đang trong thời gian đăng ký',
  'schedule.reopened': 'HR mở đăng ký lại',
  'schedule.schedule8h30': 'Ca 8h30',
  'schedule.schedule9h': 'Ca 9h',
  'schedule.history': 'Lịch sử đăng ký',
  'schedule.col.month': 'Tháng',
  'schedule.col.schedule': 'Ca',
  'schedule.col.registeredAt': 'Ngày đăng ký',
  'schedule.popupTitle': 'Đăng ký lịch làm việc tháng tới',
  'schedule.popupDesc': 'Vui lòng chọn ca làm việc cho tháng',
  'schedule.popupNote': 'Mặc định: Ca 9h nếu không đăng ký trước hạn.',
  'schedule.later': 'Để sau',
};
